<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">我的优惠券</h1>
            <div class="fv_top">
                <a href="javascript:;" @click="$router.push({path: '/user_coupon', query:{status:'未使用',showVideo:1,}})" class="fv_tli ">未使用</a>
                <a href="javascript:;" @click="$router.push({path: '/use_coupon', query:{status:'已使用',showVideo:1,}})" class="fv_tli ">已使用</a>
                <a href="javascript:;" @click="$router.push({path: '/expired_coupon', query:{status:'兑换优惠券',showVideo:1,}})" class="fv_tli fv_ton">兑换优惠券</a>
            </div>
            <public-nothing v-if="tableData.data == []"></public-nothing>
            <div class="bn_list" v-else>
                <div v-for="(item,index) in tableData.data" :key="index">
                    <div class="fx couponItem_detail1" v-if="item.cdn_pid > 0">
                        <div class="ci_div_img">
                            <img :src="$fnc.getImgUrl(item.p_piclink)" alt="" style="border-radius: 12px;" width="80">
                        </div>
                        <div class="fx ci_div_info1" style="width: 350px;">
                            <p class="ci_div_info1_p1">
                                <span class="price_regular">
                                    <small>￥</small><b>{{$fnc.get_int_dec(item.money,'int')}}</b><i>.00</i>
                                </span>
                                <span>满{{item.cdn_xfm}}减{{$fnc.get_int_dec(item.money,'int')}}</span>
                            </p>
                            <p class="ci_div_info1_p2 van-ellipsis">{{item.p_title | ellipsis}}</p>
                            <p class="ci_div_info1_p3">领后{{item.lifetime}}天有效</p>
                        </div>
                        <div class="fx ci_div_btn1">
                            <button class="van-button van-button--warning van-button--mini van-button--round" @click="user_coupon_zjlq(item)">
                                <div class="van-button__content">
                                    <span class="van-button__text">{{item.pay_types==0?'立即领取':'立即兑换'}}</span>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="fx couponItem_detail1" v-else>
                        <div class="ci_div_img">
                            <img src="../../assets/picture/index/hongbaored.png" alt="" style="border-radius: 12px;" width="80">
                        </div>
                        <div class="fx ci_div_info1" style="width: 350px;">
                            <p class="ci_div_info1_p1">
                                <span class="price_regular">
                                    <small>￥</small><b>{{$fnc.get_int_dec(item.money,'int')}}</b><i>.00</i>
                                </span>
                                <span>满{{item.cdn_xfm}}减{{$fnc.get_int_dec(item.money,'int')}}</span>
                            </p>
                            <p class="ci_div_info1_p2 van-ellipsis">{{item.title | ellipsis}}</p>
                            <p class="ci_div_info1_p3">领后{{item.lifetime}}天有效</p>
                        </div>
                        <div class="fx ci_div_btn1">
                            <button class="van-button van-button--warning van-button--mini van-button--round" @click="user_coupon_zjlq(item)">
                                <div class="van-button__content">
                                    <span class="van-button__text">{{item.pay_types==0?'立即领取':'立即兑换'}}</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Public_nothing from "./no-coupon.vue"
export default {
    filters: {//限制文本显示字数,超出部分用...代替
        ellipsis (value) {
        if (!value) return ''
        if (value.length > 10) {
            return value.slice(0,10) + '...'//0:下标,从第一个字开始显示,50:显示字数,多余用...代替
        }
            return value
        }
    },
    components:{
        'public-nothing': Public_nothing,
    },
    data(){
        return{
            list:[],
            is_friend: 0,
            status:0,
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                page: 1,
                page_size: 10,
                status:0,
                type:"",
                id:JSON.parse(window.localStorage.getItem("user")).id ? JSON.parse(window.localStorage.getItem("user")).id : "",
            },
        }
    },
    mounted(){
        this.getList(1);
        this.getCouponList(JSON.parse(window.localStorage.getItem("user")).id);
    },
    methods:{
        getCouponList(id) {
            var params = {};
            params.id = id || "";
            // params.status = this.$route.query.status || "";
            // this.dialogVisible = true;
            // this.LogLoading = true;
            this.$api.getCoupon.getPacketLists(params).then(res => {
                if (res.code == 200) {
                    if(res.result == ''){
                        this.tableData.data = [];
                    }else{
                        this.tableData.data = res.result[0].red;
                        // this.tableData.total = res.result.counts;  // 总条目数
                        // this.tableData.page = res.result.page;
                        // this.tableData.page_size = res.result.pageSize;
                        // this.listLoading = false;
                    }
                }
            });
        },
        //列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getCoupon.getPacketLists(this.tableFrom).then((res) => {
                
                if (res.code == 200) {
                    if(res.result == ''){
                        this.tableData.data = [];
                    }else{
                        this.tableData.data = res.result[0].red;
                        // this.tableData.total = res.result.counts;  // 总条目数
                        // this.tableData.page = res.result.page;
                        // this.tableData.page_size = res.result.pageSize;
                        // this.tableData.id = JSON.parse(window.localStorage.getItem("data")).id;
                        // this.listLoading = false;
                    }
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
        user_coupon_zjlq(item){
            item.money = Math.floor(parseFloat(item.money) * 100) / 100;
            if(item.pay_types == 1){
                this.$confirm(`是否消耗${item.jf_change}积分兑换${item.money}元优惠券`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.getShop.exchange_mark({ id: item.id,uid: JSON.parse(window.localStorage.getItem("user")).id}).then((res) => {
                        console.log(res);
                        if (res.code == 200) {
                            this.$alert('兑换成功', '提示', {
                                confirmButtonText: '确定',
                            });
                            setTimeout(() => {
                                this.$emit("changeTab", 0);
                            }, 1500);
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
            }else if(item.pay_types == 2){
                this.$confirm(`是否消耗￥${item.jf_change}兑换${item.money}元优惠券`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.getCoupon.coupon_packet_ye({ id: item.id,uid: JSON.parse(window.localStorage.getItem("user")).id }).then((res) => {
                        if (res.code == 200) {
                            var str = res.result;
                            if (isNaN(Number(str))) {
                                this.$emit("changeTab", 0);
                            }
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
            } else if (item.pay_types == 0) {
                this.$confirm(`是否领取优惠券`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.getShop.getLingquCoupon({ id: item.id,uid: JSON.parse(window.localStorage.getItem("user")).id }).then((res) => {
                        if (res.code == 200) {
                            this.$alert('领取成功', '提示', {
                                confirmButtonText: '确定',
                            });
                        }else{
                            this.$alert('已领取过了，请消费已有的优惠券再来领取！', '提示', {
                                confirmButtonText: '确定',
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
            }
        }
    },
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
.couponItem_detail1 {
    height: 100%;
    margin: 4px;
    border-radius: 10px;
    background: -webkit-gradient(linear,left top,right top,from(#ff735c),to(#fd3f31));
    background: linear-gradient(90deg,#ff735c,#fd3f31);
    width: 48%;
    float: left;
}
.couponItem_detail1 .ci_div_img {
    padding: 10px;
}
.couponItem_detail1 .ci_div_btn1 {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 150px;
    height: 100%;
    padding: 40px 20px;
    border-left: 1px solid #ff6153;
    text-align: center;
    border-radius: 15px 0 0 15px;
}
.couponItem_detail1 .ci_div_info1 {
    /* width: 81px; */
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 1px 0 2px;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
}
.couponItem_detail1 .ci_div_info1 .ci_div_info1_p1 {
    font-family: gilroy!important;
}
.couponItem_detail1 .ci_div_info1>p {
    width: 100%;
    font-size: 14px;
    line-height: 1.2;
    color: #fff0c3;
}
.fx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
}
.couponItem_detail1 .ci_div_info1 .ci_div_info1_p1 .price_regular {
    margin-right: 2px;
}
.couponItem .price_regular {
    margin-right: 2px;
}
.price_regular, .price_sign {
    font-family: gilroy!important;
    font-size: 14px;
}
/* .price_regular { */
    /* color: #ff5a00!important; */
/* } */
.couponItem_detail1 .ci_div_info1 .ci_div_info1_p2 {
    padding-bottom: 2px;
}
.couponItem .couponItem_detail1 .ci_div_info1>p {
    width: 100%;
    font-size: 14px;
    line-height: 1.2;
    color: #fff0c3;
}
.van-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.couponItem_detail1 .ci_div_info1 .ci_div_info1_p3 {
    font-size: 14px;
}
.couponItem_detail1 .ci_div_info1>p {
    width: 100%;
    font-size: 14px;
    line-height: 1.2;
    color: #fff0c3;
}
.couponItem_detail1 .ci_div_info1 .ci_div_info1_p1 .price_regular>small {
    color: #fff0c3;
    font-size: 14px;
    font-weight: 700;
}
.couponItem_detail1 .ci_div_info1 .ci_div_info1_p1 .price_regular>b {
    color: #fff0c3;
    font-size: 30px;;
}
.couponItem_detail1 .ci_div_info1 .ci_div_info1_p1 .price_regular i {
    color: #fff0c3;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
}
/*  */
.couponItem_detail1 .ci_div_btn1 .van-button[data-v-b201f3a6] {
    color: #d22018;
    font-size: 14px;
    padding-top: 10px;
    background: -webkit-gradient(linear,left top,right top,from(#ffedd9),to(#fbb06c));
    background: linear-gradient(90deg,#ffedd9,#fbb06c);
}
.van-button--round {
    border-radius: 30px;
}
.van-button--mini {
    height: 20px;
    padding: 0 20px;
    font-size: 16px;
}
.van-button--warning {
    color: #fff;
    background-color: #ff976a;
    border: 1px solid #ff976a;
}
.van-button {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 5px 10px;
    font-size: 16px;
    line-height: 1.2;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
    -webkit-appearance: none;
}
.van-button:before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background-color: #000;
    border: inherit;
    border-color: #000;
    border-radius: inherit;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    opacity: 0;
    content: " ";
}
.van-button__content {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    height: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/coupon/expired_coupon.vue